export default __webpack_public_path__ + "static/media/element_74.19f3579f.webp";